import React from 'react';

import { LegacyText, styled, LegacyBox } from '@gogame/components';

export const ErrorText = styled(LegacyText)`
  color: ${(props) => props.theme.palette.error.main};
`;

export const ErrorMessage = styled((props) => (
  <LegacyBox
    justifyContent={'center'}
    style={{ padding: '8px', minHeight: '20px' }}
    data-cy={'errorMessage'}
  >
    <ErrorText variant={'body2'}>{props.children}</ErrorText>
  </LegacyBox>
))``;
